import { firebaseServiceOne } from '../../../services/service-factory';

export default {
  data: function() {
    return {
      firebaseServiceOne: undefined
    };
  },
  created: function() {
    this.firebaseServiceOne = firebaseServiceOne;
  }
};
